import * as _ from 'lodash';
import { PayGroup } from '../../../shared/models/pay-group.model';
import { CompanyBasicInfo } from '../../../services/company.model';

export class CompanyInfoFilters {

  constructor(
    public payGroups: PayGroup[] = [],
    public companies: CompanyBasicInfo[] = [],
    public companyCodes: string[] = [],
    public feins: string[] = [],
    public prenoteFileSentYes: boolean | null,
    public prenoteFileSentNo: boolean | null
  ) {  }

  get prenoteFileSent(): boolean {
    if ((this.prenoteFileSentYes === null && this.prenoteFileSentNo === null) ||
        (this.prenoteFileSentYes === this.prenoteFileSentNo)) {
      return null;
    }

    if (this.prenoteFileSentYes) {
      return true;
    }

    if (this.prenoteFileSentNo) {
      return false;
    }

    return null;
  }

  static areEqual(a: CompanyInfoFilters, b: CompanyInfoFilters): boolean {
    if (!!a !== !!b) {
      return false;
    }
    if (!a) {
      return true;
    }

    if (!CompanyInfoFilters._areEqual(a.payGroups, b.payGroups)) {
      return false;
    }

    if (!CompanyInfoFilters._areEqual(a.companies, b.companies)) {
      return false;
    }

    if (!CompanyInfoFilters._areEqual(a.companyCodes, b.companyCodes)) {
      return false;
    }

    if (!CompanyInfoFilters._areEqual(a.feins, b.feins)) {
      return false;
    }

    if (a.prenoteFileSentYes !== b.prenoteFileSentYes) {
      return false;
    }

    if (a.prenoteFileSentNo !== b.prenoteFileSentNo) {
      return false;
    }

    return true;
  }

  private static _areEqual(a: any[], b: any[]): boolean {
    if (!a) {
      return !b || !b.length;
    }
    if (!b) {
      return !a.length;
    }

    if (a.length !== b.length) {
      return false;
    }

    return _.isEqual(a, b);
  }

  copy(): CompanyInfoFilters {
    return new CompanyInfoFilters(
      this.payGroups,
      this.companies,
      this.companyCodes,
      this.feins,
      this.prenoteFileSentYes,
      this.prenoteFileSentNo);
  }

  clone(): CompanyInfoFilters {
    const newFilters = _.clone(this);
    return newFilters;
  }

  reset() {
    this.payGroups = [];
    this.companies = [];
    this.companyCodes = [];
    this.feins = [];
    this.prenoteFileSentYes = null;
    this.prenoteFileSentNo = null;
  }
}
